'use client';

import { useEffect } from 'react';

/**
 * Request the document's configured OneTrust SDK once the shared page shell
 * mounts, including when entering a page through client navigation.
 */
const CookieScript = () => {
  useEffect(() => {
    globalThis.__osmosisInitializeOneTrust?.();
  }, []);

  return null;
};

export default CookieScript;
